export default __webpack_public_path__ + "static/media/view2_week_province.cb22bbbd.csv";